export default __webpack_public_path__ + "498039cd550aff57bf38f45e88bb1eab.png";